import { appletEmptyStateReportsTitleText } from '../../translations/translation-keys';
import { generatePrefixedTagName } from '../../generate-prefixed-tag-name';
import { getTranslations } from '../../translations';
import { reportsImage } from './reports-image.png';
import { safelyDefineCustomElement } from '../../safely-define-custom-element';

import styleText from './index.scss';

export class AppletEmptyStateReports extends HTMLElement {
    static get tagName() {
        return generatePrefixedTagName`applet-empty-state-reports`;
    }

    constructor() {
        super();
        this.__root = this.attachShadow({mode: 'open'});
    }

    async connectedCallback() {
        const translation = await getTranslations();
        const title = translation.getTranslation(appletEmptyStateReportsTitleText);

        this.__root.innerHTML = `
        <style>${styleText}</style>
        <img src="${reportsImage}" alt="${title}">
        <span class="applet-empty-state-reports__title-text">${title}</span>
        `;
    }
}

safelyDefineCustomElement(AppletEmptyStateReports);